import type { ReactNode } from 'react';

export const symbol_battery_android_bolt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-37.5 0-63.75-26.25T40-330v-300q0-37.5 26.25-63.75T130-720h555q15 0 22.5 9.32t7.5 20.5q0 11.18-7.5 20.68T685-660H130q-12.75 0-21.37 8.62Q100-642.75 100-630v300q0 12.75 8.63 21.37Q117.25-300 130-300h484q15 0 22.5 9.32t7.5 20.5q0 11.18-7.5 20.68T614-240H130Zm-30-60v-360 360Zm635-140H631q-9.75 0-13.87-8-4.13-8 1.87-16l182-227q4-5 9-2.5t4 8.5l-29 165h104q9.75 0 13.88 8 4.12 8-1.88 16L719-269q-4 5-9 2.5t-4-8.5l29-165Z"
		/>
	</svg>
);
